import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import KimoneSellsOrlando from './components/KimoneSellsOrlando';
import KimoneSellsOrlandoBuy from './components/KimoneSellsOrlandoBuy';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<KimoneSellsOrlando />} />
          <Route path="/buy" element={<KimoneSellsOrlandoBuy />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
